<template>
    <v-container fluid>
        <v-row align="center">
            <v-col class="text-right">
                <span class="text-sm">{{ wochentag }}</span><br/>
                <span class="text-sm">{{ datum }}</span>
            </v-col>
            <v-col cols="auto">
                <div class="text-xl font-weight-bold">{{ uhrzeit_std }}<span :class="trennerFarbe">:</span>{{ uhrzeit_min }}</div>
            </v-col>
        </v-row>
    </v-container>
</template>
<script>
export default {
    name: 'kc-clock',
    data() {
        return {
            zeit: this.$dayjs(),
            timer: null,
            trennerFarbe: 'text-primary'          
        }
    },
    computed: {
        uhrzeit_std() {
            const vm = this;
            return vm.zeit.format('HH');
        },                
        uhrzeit_min() {
            const vm = this;
            return vm.zeit.format('mm');
        },
        wochentag() {
            const vm = this;
            return vm.zeit.format('dddd');
        },
        datum() {
            const vm = this;
            return vm.zeit.format('DD. MMMM YYYY');
        }
    },
    mounted() {
        const vm = this;
        vm.timer = window.setInterval(() => {
            vm.zeit = vm.$dayjs();
            if (vm.trennerFarbe == 'uhrzeitTrennerSichtbar')
                vm.trennerFarbe = 'uhrzeitTrennerUnsichtbar';
            else
                vm.trennerFarbe = 'uhrzeitTrennerSichtbar';
        }, 1000);
    },
    demounted() {
        const vm = this;
        if (vm.timer !== null) vm.timer.stop();
    }
}
</script>
<style lang="scss" scoped>
</style>
